export class ActivityResultSettingDto {
    activityResultSettingId: number;
    clientId: number;
    requestTypeId: number;
    isArrivedToTSC: boolean;
    nextActivityStatusId: number;
    activityResultId: number;
    externalStatus: string;
    externalStatusPriority: number;
}